<template>
  <v-app id="inspire">
    <div>
      <v-navigation-drawer
        v-model="drawer"
        app
        dark
        color="transparent"
        class="gloomy"
        width="350"
      >
        <div class="pa-3 bg-logo d-flex align-center justify-center">
          <v-img
            v-if="logoUrl"
            :src="logoUrl"
            contain
            max-height="110"
            max-width="280"
            class="logo-img"
          ></v-img>
          <v-img
            v-else
            :src="require('../../assets/smart-pju.png')"
            contain
            max-height="110"
            max-width="280"
            class="logo-img"
          ></v-img>
        </div>

        <div v-if="isMobile()" class="mt-4">
          <v-list dense nav>
            <v-list-item to="/dashboard">
              <v-icon small class="mr-2">mdi-home</v-icon>
              <v-list-item-title>Dashboard</v-list-item-title>
            </v-list-item>

            <v-list-item to="/viewmap">
              <v-icon small class="mr-2">mdi-map-marker-outline</v-icon>
              <v-list-item-title>Map View</v-list-item-title>
            </v-list-item>

            <v-list-item to="/viewlist">
              <v-icon small class="mr-2">mdi-view-list</v-icon>
              <v-list-item-title>List View</v-list-item-title>
            </v-list-item>
          </v-list>

          <v-divider></v-divider>
        </div>

        <v-row style="margin-bottom: 90px">
          <v-col col="12" class="my-4 mx-3">
            <v-list-item dark v-if="false"> {{ userInfo }}xx </v-list-item>
            <select-tenant
              :dataset="tenantList"
              class="mb-2"
              v-if="userInfo.role_name == 'user_tenant'"
            ></select-tenant>
            <filter-view :loading="isLoading" @search="doSearch"></filter-view>
            <select-device
              :dataset="deviceList"
              @onselection="onSelection"
            ></select-device>
          </v-col>
        </v-row>
      </v-navigation-drawer>

      <v-app-bar
        app
        class="mt-2 mb-2 ml-4 mr-4"
        elevation="0"
        outlined
        dense
        v-if="!isMobile()"
      >
        <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>

        <v-tabs align-with-title v-if="!isMobile()">
          <v-tab to="/dashboard">
            <v-icon small>mdi-home</v-icon>
            <span class="ml-2">Dashboard</span>
          </v-tab>

          <v-tab to="/viewmap">
            <v-icon small>mdi-map-marker-outline</v-icon>
            <span class="ml-2">Map View</span>
          </v-tab>

          <v-tab to="/viewlist">
            <v-icon small>mdi-view-list</v-icon>
            <span class="ml-2">List View</span>
          </v-tab>
        </v-tabs>

        <!-- NOTIFICATION BELL ICON -->
        <v-menu offset-y v-model="notificationMenu" :close-on-content-click="false" v-if="userRole !== 'guest'">
          <template #activator="{ on, attrs }">
            <v-btn class="mr-1" icon color="default" v-bind="attrs" v-on="on">
              <v-badge
                color="red"
                :content="totalUnreadCount"
                :value="totalUnreadCount > 0"
                overlap
              >
                <v-icon dark>mdi-bell-outline</v-icon>
              </v-badge>
            </v-btn>
          </template>
          <!-- Di sini Anda akan menempatkan komponen daftar notifikasi -->
          <v-card class="custom-data-card" min-width="300" max-width="400" style="background: #0a1f3b !important; border: 1px solid rgba(0, 255, 255, 0.3);">
            <v-list dense class="notification-list pt-0" style="background: transparent !important;">
              <v-list-item
                v-for="(notification, index) in mergedNotifications"
                :key="index"
                @click="handleNotificationClick(notification)"
                class="list-hover"
              >
                    <v-list-item-content>
                      <v-list-item-title class="cyan--text">{{ notification.message }}</v-list-item-title>
                    </v-list-item-content>
              </v-list-item>

              <v-list-item v-if="mergedNotifications.length === 0">
                <v-list-item-title class="cyan--text">Tidak ada notifikasi</v-list-item-title>
              </v-list-item>
            </v-list>

            <v-divider v-if="mergedNotifications.length > 0" style="border-color: rgba(0, 255, 255, 0.2) !important;"></v-divider>
            
            <v-card-actions v-if="mergedNotifications.length > 0" class="pa-2" style="background: rgba(0, 0, 0, 0.2);">
               <v-btn small text color="cyan" @click.stop="handleClearAllNotifications" width="100%" class="font-weight-bold">
                 Clear All Notifications
               </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>

        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="mr-1" icon color="default" v-bind="attrs" v-on="on">
              <v-icon dark> mdi-account-outline </v-icon>
            </v-btn>
          </template>
          <v-list class="custom-data-card">
            <v-list-item>
              <div class="user-info">
                <span
                  style="
                    text-align: center;
                    width: 100%;
                    border-bottom: 1px solid;
                    border-color: rgba(0, 255, 255, 0.3) !important;
                    margin-bottom: 8px;
                    font-weight: bold;
                  "
                  >ACCOUNT</span
                >
                <v-divider></v-divider>
                <span class="title-color">{{ userInfo.fullname }}</span>
                <span class="subtitle-color">{{ userInfo.username }}</span>
              </div>
            </v-list-item>
            <v-list-item-group v-model="selectedItem" color="primary">
              <v-list-item class="list-hover" v-if="false">
                <v-list-item-title>Change Password</v-list-item-title>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item @click="dialog = true">
                <v-icon>mdi-circle-edit-outline </v-icon>
                <v-list-item-title class="text-cyan ml-2"
                  >Change Logo</v-list-item-title
                >
              </v-list-item>
              <v-list-item class="list-hover" @click="logout">
                <v-icon>mdi-power </v-icon>
                <v-list-item-title class="text-cyan ml-2"
                  >Logout</v-list-item-title
                >
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-menu>

        <v-btn
          v-if="false"
          class="mr-1"
          icon
          color="default"
          @click="rightDrawer = !rightDrawer"
        >
          <v-icon dark>mdi-store-cog</v-icon>
        </v-btn>
      </v-app-bar>

      <v-app-bar
        app
        class="mt-2 mb-2 ml-4 mr-4"
        elevation="0"
        outlined
        dense
        v-if="isMobile()"
      >
        <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>

        <v-img
          v-if="logoUrl"
          :src="logoUrl"
          contain
          max-height="110"
          max-width="280"
          class="logo-img"
        ></v-img>
        <v-img
          v-else
          :src="require('../../assets/smart-pju.png')"
          contain
          max-height="110"
          max-width="280"
          class="logo-img"
        ></v-img>
        <v-spacer></v-spacer>

        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="mr-1" icon color="default" v-bind="attrs" v-on="on">
              <v-icon dark> mdi-account-outline </v-icon>
            </v-btn>
          </template>
          <v-list class="custom-data-card">
            <v-list-item>
              <div class="user-info">
                <span
                  style="
                    text-align: center;
                    width: 100%;
                    border-bottom: 1px solid;
                    border-color: rgba(0, 255, 255, 0.3) !important;
                    margin-bottom: 8px;
                    font-weight: bold;
                  "
                  >ACCOUNT</span
                >
                <v-divider></v-divider>
                <span class="title-color">{{ userInfo.fullname }}</span>
                <span class="subtitle-color">{{ userInfo.username }}</span>
              </div>
            </v-list-item>
            <v-list-item-group v-model="selectedItem" color="primary">
              <v-list-item class="list-hover" v-if="false">
                <v-list-item-title>Change Password</v-list-item-title>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item @click="dialog = true">
                <v-icon>mdi-circle-edit-outline </v-icon>
                <v-list-item-title class="text-cyan ml-2"
                  >Change Logo</v-list-item-title
                >
              </v-list-item>
              <v-list-item class="list-hover" @click="logout">
                <v-icon>mdi-power </v-icon>
                <v-list-item-title class="text-cyan ml-2"
                  >Logout</v-list-item-title
                >
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-menu>

        <v-btn
          v-if="false"
          class="mr-1"
          icon
          color="default"
          @click="rightDrawer = !rightDrawer"
        >
          <v-icon dark>mdi-store-cog</v-icon>
        </v-btn>
      </v-app-bar>
    </div>
    <v-main>
      <div class="pa-4 mt-2">
        <!-- Banner status berlangganan: muncul otomatis jika hampir/sudah expired -->
        <subscription-banner />
        <router-view></router-view>
      </div>

      <v-row justify="space-around">
        <v-col cols="auto">
          <v-dialog max-width="600" v-model="dialog" :style="{ zIndex: 10001 }">
            <v-card class="custom-data-card">
              <v-toolbar color="#102242" dark>
                <v-toolbar-title class="title-text"
                  >Change Logo</v-toolbar-title
                >
                <v-spacer></v-spacer>
                <v-btn icon dark @click="dialog = false">
                  <v-icon color="#102242">mdi-close</v-icon>
                </v-btn>
              </v-toolbar>

              <v-card-text>
                <v-file-input
                  v-model="selectedFile"
                  label="Pilih Logo"
                  accept="image/*"
                  filled
                  prepend-icon="mdi-camera"
                  color="cyan lighten-2"
                  class="custom-file-input"
                ></v-file-input>
              </v-card-text>

              <v-card-actions class="justify-end">
                <v-btn
                  outlined
                  color="#00ffff"
                  class="btn-outline"
                  text
                  @click="dialog = false"
                  >Cancel</v-btn
                >
                <v-btn
                  color="#00ffff"
                  class="btn-filled"
                  dark
                  @click="uploadNewLogo"
                  :disabled="!selectedFile"
                  >Submit</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </v-main>

    <v-footer padless>
      <v-col class="text-center" cols="12">
        {{ new Date().getFullYear() }} — <strong>Smart APJ</strong>
      </v-col>
    </v-footer>

    <!-- Group Control Result Dialog -->
    <v-dialog v-model="groupControlDialog" max-width="550" persistent>
      <v-card class="custom-data-card" style="background: #0a1f3b !important; border: 1px solid rgba(0, 255, 255, 0.3);">
        <v-card-title class="text-cyan pt-4">
          <v-icon left color="#00ffff">mdi-information-outline</v-icon>
          Process Complete
        </v-card-title>

        <v-card-text class="pt-4">
          <!-- Loading state -->
          <div v-if="groupControlLoading" class="text-center py-6">
            <v-progress-circular indeterminate color="#00ffff" size="40"></v-progress-circular>
            <div class="mt-3 cyan--text">Memuat hasil...</div>
          </div>

          <!-- Detail loaded -->
          <template v-if="!groupControlLoading && groupControlDetail">
            <!-- Action label -->
            <div class="mb-4 text-body-2" style="color: rgba(255,255,255,0.7);">
              {{ groupControlDetail.action_label || 'Group Control' }}
            </div>

            <!-- Success / Failed badges -->
            <v-row class="mb-4">
              <v-col cols="6" class="text-center">
                <v-chip color="green darken-2" dark class="px-4 py-2 font-weight-bold" label>
                  <v-icon left>mdi-check-circle</v-icon>
                  Success: {{ groupControlDetail.success || 0 }}
                </v-chip>
              </v-col>
              <v-col cols="6" class="text-center">
                <v-chip color="red darken-2" dark class="px-4 py-2 font-weight-bold" label>
                  <v-icon left>mdi-alert-circle</v-icon>
                  Failed: {{ groupControlDetail.fail || 0 }}
                </v-chip>
              </v-col>
            </v-row>

            <!-- Error messages -->
            <div v-if="groupControlDetail.errors && groupControlDetail.errors.length > 0" class="mt-4">
              <div class="text-subtitle-2 mb-2 font-weight-bold" style="color: #00ffff;">Errors:</div>
              <v-sheet
                color="rgba(0, 0, 0, 0.4)"
                class="pa-3 rounded"
                outlined
                style="border: 1px solid rgba(0, 255, 255, 0.2); max-height: 250px; overflow-y: auto;"
              >
                <div
                  v-for="(msg, idx) in groupControlDetail.errors"
                  :key="idx"
                  class="text-body-2 white--text mb-1"
                >
                  {{ msg }}
                </div>
              </v-sheet>
            </div>

            <!-- All success message -->
            <div v-if="groupControlDetail.fail === 0" class="mt-3 text-center">
              <v-icon color="green" large>mdi-check-circle</v-icon>
              <div class="mt-1" style="color: #aaffaa;">Semua perangkat berhasil menerima perintah!</div>
            </div>
          </template>
        </v-card-text>

        <v-card-actions class="pb-4 px-4 justify-end">
          <v-btn
            color="cyan"
            class="black--text"
            min-width="110"
            @click="groupControlDialog = false; groupControlDetail = null;"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-app>
</template>



<style scoped>
.notification-list {
  max-height: 400px; /* Atur tinggi maksimum sesuai kebutuhan */
  overflow-y: auto;  /* Tambahkan scrollbar vertikal jika konten melebihi max-height */
}
.v-divider {
  border-color: rgba(0, 255, 255, 0.3) !important;
}
.title-text {
  color: #00ffff !important;
  font-weight: bold;
}

.custom-file-input .v-file-input__text {
  color: #00ffff !important;
  font-weight: 500;
}

.custom-file-input .v-label {
  color: #009688 !important;
}

/* BUTTONS */
.btn-outline {
  border: 1px solid #00ffff !important;
  color: #00ffff !important;
  text-transform: uppercase;
  letter-spacing: 0.6px;
}

.btn-outline:hover {
  background-color: rgba(0, 255, 255, 0.1) !important;
}

.btn-filled {
  background-color: #00ffff !important;
  color: #1e1e2f !important;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  font-weight: 600;
  transition: all 0.25s ease;
}

.btn-filled:hover {
  background-color: #18ffff !important;
  transform: scale(1.03);
}

.dialog-title {
  color: red;
}
.user-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: right;
  margin-left: auto;
  padding-top: 4px;
  padding-bottom: 4px;
}

.bg-logo {
  background: rgba(15, 35, 70, 0.5) !important;
  box-shadow: 0 4px 12px rgba(0, 255, 255, 0.1); /* efek cyan halus */
  text-align: center;
  transition: all 0.3s ease;
}

.bg-logo:hover {
  box-shadow: 0 4px 16px rgba(0, 255, 255, 0.3);
  transform: translateY(-2px);
}

.logo-img {
  filter: drop-shadow(0 0 4px rgba(0, 255, 255, 0.4));
}
/* Tema utama navbar & drawer */
.v-application {
  background: radial-gradient(circle at top, #0a1f3b 0%, #071426 80%);
  color: #d8faff;
}

/* Drawer bergaya kaca */
.v-navigation-drawer.gloomy {
  background: rgba(10, 31, 59, 0.75) !important;
  backdrop-filter: blur(14px);
  border-right: 1px solid rgba(0, 234, 255, 0.2);
  box-shadow: 2px 0 15px rgba(0, 234, 255, 0.05);
}

.v-navigation-drawer .v-list-item {
  color: #cbefff !important;
}

.v-navigation-drawer .v-list-item:hover {
  background: rgba(0, 234, 255, 0.08) !important;
  color: #00eaff !important;
}

/* App-bar transparan */
.v-app-bar {
  background: rgba(15, 35, 70, 0.5) !important;
  backdrop-filter: blur(12px);
  border: 1px solid rgba(0, 234, 255, 0.25);
  border-radius: 10px;
  color: #e8faff !important;
}

/* Tabs warna cyan lembut */
.v-tab {
  color: #b8eaff !important;
  transition: 0.3s;
}

.v-tab:hover {
  color: #00eaff !important;
  text-shadow: 0 0 8px rgba(0, 234, 255, 0.4);
}

.v-tab.v-tab--active {
  color: #00eaff !important;
  border-bottom: 2px solid #00eaff !important;
}

/* Ikon dan teks user */
.title-color {
  color: #00ffff !important;
  font-weight: 400;
}

.subtitle-color {
  color: #a9e9ff !important;
}

/* Tombol icon di kanan atas */
.v-btn.icon {
  color: #00eaff !important;
}

.custom-data-card {
  backdrop-filter: blur(18px);
  background: none;
  border: 1px solid rgba(0, 255, 255, 0.2);
  border-radius: 12px;
  box-shadow: 0 0 15px rgba(0, 200, 255, 0.1);
  transition: all 0.3s ease;
}

.v-list-item:hover {
  color: #00eaff !important;
  text-shadow: 0 0 8px rgba(0, 234, 255, 0.4);
}

/* Dialog change logo */
.v-dialog .v-card {
  background: rgba(15, 35, 70, 0.85);
  color: #dffaff;
  border: 1px solid rgba(0, 234, 255, 0.3);
  backdrop-filter: blur(10px);
}

.v-dialog .v-toolbar {
  background: rgba(0, 234, 255, 0.15);
}
.v-toolbar {
  background: linear-gradient(
    90deg,
    rgba(0, 234, 255, 0.2),
    rgba(0, 234, 255, 0.05)
  ) !important;
  color: #00eaff !important;
  font-weight: 600;
  letter-spacing: 0.5px;
}

/* Footer */
.v-footer {
  background: rgba(10, 31, 59, 0.6);
  color: #b9e9f5 !important;
  border-top: 1px solid rgba(0, 234, 255, 0.2);
  text-shadow: 0 0 4px rgba(0, 234, 255, 0.3);
}

.v-icon {
  color: #b8eaff !important;
}

.text-cyan {
  color: #b8eaff !important;
  transition: 0.3s;
}
</style>

<script>
import xstore from "@/store/index.js";
import { mapActions, mapGetters } from "vuex";
import FilterView from "./FilterView";
import SelectDevice from "./SelectDevice";
import SelectTenant from "./SelectTenant";
import SubscriptionBanner from "@/components/SubscriptionBanner";

export default {
  components: {
    FilterView,
    SelectDevice,
    SelectTenant,
    SubscriptionBanner,
  },

  data: () => ({
    dialog: false,
    selectedFile: null,

    drawer: null,
    drawerMode: 1,
    rightDrawer: false,
    selectedItem: "",
    queryFilter: {},
    xdeviceList: [{ devicecode: "01", devicename: "Test" }],
    userInfo: {},
    // Group Control Result Dialog
    groupControlDialog: false,
    groupControlDetail: null,
    groupControlLoading: false,
  }),

  methods: {
    ...mapActions("logo", ["fetchLogo", "uploadLogo"]),

    async uploadNewLogo() {
      try {
        await this.uploadLogo(this.selectedFile);
        this.selectedFile = null;
        this.$toast?.success("Logo berhasil diupload!");
        this.dialog = false;
      } catch (e) {
        this.$toast?.error("Gagal upload logo");
      }
    },

    fetchNotifications() {
      this.$store.dispatch("notifications/fetchNotifications");
    },

    handleNotificationClick(notification) {
      // Close the menu
      this.notificationMenu = false;

      if (notification.type === 'device_alert') {
        // 1. Mark as read
        this.$store.dispatch('devices/markAllAlertsAsReadForDevice', notification.devicecode);

        // 2. Navigate
        if (this.$route.path !== '/viewlist') {
             this.$router.push({ path: '/viewlist', query: { devicecode: notification.devicecode } });
        } else {
             this.autoSelectDevice(notification.devicecode);
        }
      } else if (notification.type === 'group_control_result') {
        // Tampilkan dialog detail hasil group control
        this.openGroupControlDetail(notification);
      } else {
        this.$store.dispatch("notifications/markAsRead", notification.id);
      }
    },

    async openGroupControlDetail(notification) {
      this.groupControlDialog = true;
      this.groupControlLoading = true;
      this.groupControlDetail = null;

      try {
        const result = await this.$store.dispatch('devices/getGroupControlDetail', {
          alertId: notification.alertId,
        });
        const resData = result && result.data ? result.data : result;
        if (resData && resData.detail) {
          this.groupControlDetail = resData.detail;
        } else {
          this.groupControlDetail = { errors: [], success: 0, fail: 0, action_label: notification.message };
        }
      } catch (err) {
        console.error('Failed to fetch group control detail:', err);
        this.groupControlDetail = { errors: [err.message || 'Gagal memuat detail'], success: 0, fail: 0, action_label: notification.message };
      } finally {
        this.groupControlLoading = false;
        // Mark as read
        if (notification.alertId) {
          try {
            await this.$store.dispatch('devices/fetchUnreadAlerts');
          } catch (e) { /* ignore */ }
        }
      }
    },
    handleClearAllNotifications() {
      // Close the menu
      this.notificationMenu = false;
      
      this.$store.dispatch('devices/markAllAlertsAsReadGlobal');
      // Optionally mark generic system notifications as read too if desired
      // this.$store.dispatch('notifications/markAllAsRead'); 
    },

    isMobile() {
      return screen.width <= 760;
    },

    onSelection(selection) {
      this.$store.dispatch("devices/selectDeviceItem", selection);
      
      // List of routes where we want to stay on the same page
      const allowedRoutes = ['Dashboard', 'viewmap', 'viewlist'];
      
      if (selection && selection.devicecode && selection.devicecode !== 'all') {
        // If we are NOT in one of the allowed routes, redirect to Dashboard
        if (!allowedRoutes.includes(this.$route.name)) {
           this.$router.push({ name: 'Dashboard' });
        }
        // If we are already on Dashboard, viewmap, or viewlist, do nothing (stay there)
      } else {
        // If "All Devices" is selected
        if (!allowedRoutes.includes(this.$route.name)) {
           this.$router.push({ name: 'Dashboard' });
        }
      }
    },

    logout() {
      this.$store
        .dispatch("LOGOUT", {
          username: this.username,
          password: this.password,
        })
        .then(() => {
          this.$router.push("/login");
          location.reload();
        })
        .catch(function (err) {
          console.log(err.response);
        });
    },

    doSearch(data) {
      this.queryFilter = data;
      this.$store.dispatch("devices/refreshDeviceTree", this.queryFilter);
    },

    autoSelectDevice(devCode) {
      if (!devCode || !this.deviceList) return;

      const device = this.deviceList.find((d) => d.devicecode === devCode);
      if (device) {
        console.log("Auto-selecting device from URL:", device);
        // Only trigger if not already selected to avoid loops
        const currentSelected = this.$store.getters["devices/deviceTreeSelected"];
        if (!currentSelected || currentSelected.devicecode !== devCode) {
          this.onSelection(device);
        }
      }
    },
  },

  computed: {
    ...mapGetters("logo", ["logoUrl"]),
    // PERBAIKAN: Petakan getter 'unreadNotifications' langsung dari Vuex
    ...mapGetters("notifications", ["unreadNotifications", "unreadNotificationCount"]),

    // --- PERBAIKAN: Computed properties untuk menggabungkan notifikasi sistem dan alert device ---
    unreadAlertsMap() {
      return this.$store.getters["devices/unreadAlerts"] || {};
    },
    
    totalUnreadCount() {
      // Return the number of items in the dropdown (Device Groups + System Notifications)
      // instead of the raw sum of all alerts which can be thousands.
      return this.mergedNotifications.length;
    },

    mergedNotifications() {
      // const notifs = this.unreadNotifications || [];
      const alerts = [];

      // Ambil semua unread alerts dari unreadAlertsMap — termasuk GROUP_CONTROL dan device_alert
      Object.keys(this.unreadAlertsMap).forEach(devicecode => {
        const alertData = this.unreadAlertsMap[devicecode];
        let count = 0;
        let message = '';

        if (typeof alertData === 'object' && alertData !== null) {
          count = alertData.unread_count || 0;
          const specificMsg = alertData.latest_message || 'alert';

          // Cek apakah ini notif Group Control
          if (alertData.alertcode === 'GROUP_CONTROL' || (specificMsg && specificMsg.startsWith('Group Control:'))) {
            message = specificMsg;
            if (count > 0) {
              alerts.push({
                id: `gc-${alertData.alertid || devicecode}`,
                alertId: alertData.alertid,
                type: 'group_control_result',
                devicecode: devicecode,
                message: message,
                timestamp: alertData.alerttime || new Date(),
              });
            }
            return;
          }

          const device = this.deviceList.find(d => d.devicecode === devicecode);
          const name = device ? device.name : devicecode;
          message = `${name}: ${specificMsg}`;
        } else {
          count = alertData;
          const device = this.deviceList.find(d => d.devicecode === devicecode);
          const name = device ? device.name : devicecode;
          message = `${name}: ${count} unread alert${count > 1 ? 's' : ''}`;
        }

        if (count > 0) {
          alerts.push({
            id: `alert-${devicecode}`,
            type: 'device_alert',
            devicecode: devicecode,
            message: message,
            timestamp: new Date() 
          });
        }
      });
      
      
      // Gabungkan. Alert device di atas.
      // return [...alerts, ...notifs];
      
      // FIX: Karena 'notifs' (dari sistem) sebenarnya mengambil data yang sama dari pju_alerts,
      // maka terjadi duplikasi. Kita gunakan 'alerts' saja yang sudah dikelompokkan per device/grup.
      return alerts;
    },
    // --- AKHIR PERBAIKAN ---

    userRole() {
      const userInfo = this.$store.getters.USER_INFO;
      return userInfo ? userInfo.role_name : '';
    },

    isLoading() {
      return this.$store.getters["devices/deviceTreeLoading"];
    },
    deviceList() {
      let vitem = this.$store.getters["devices/deviceTree"];
      if (vitem && Object.keys(vitem).length) {
        if (typeof vitem.listDevices !== "undefined") {
          return vitem.listDevices;
        }
      }
      return [];
    },
    tenantList() {
      return [
        { tenantcode: "pjudemo", tenantname: "PJU Demo" },
        { tenantcode: "neyser_pju_demo", tenantname: "Dev PJU Demo" },
        { tenantcode: "solaren_pju_demo_3", tenantname: "PJU Demo II" },
      ];
    },
  },

  // ============================================================
  // 🚀 Lifecycle Hooks
  // ============================================================

  created() {
    this.fetchLogo();
    this.userInfo = xstore.getters.USER_INFO;

    // Fetch first time
    this.$store.dispatch("notifications/fetchNotifications");
    this.$store.dispatch("devices/fetchUnreadAlerts");

    // PERBAIKAN: Tidak perlu memanggil initWebSocket() lagi,
    // karena koneksi sudah ditangani secara global di main.js
    if (this.$store.getters.USER_INFO) {
        console.log("🔌 [GUI-INIT] Waiting for real-time notifications for group:", this.$store.getters.USER_INFO.data_group);
    }
  },

  beforeDestroy() {
    // PERBAIKAN: Tidak perlu membersihkan koneksi di sini,
    // karena instance socket bersifat global dan persisten.
  },

  watch: {
    "$route.query.devicecode": {
      immediate: true,
      handler(newDevCode) {
        if (newDevCode) {
          this.autoSelectDevice(newDevCode);
        }
      },
    },
    deviceList: {
      immediate: true,
      handler(newList) {
        const devCode = this.$route.query.devicecode;
        if (devCode && newList && newList.length > 0) {
          this.autoSelectDevice(devCode);
        }
      },
    },
  },
};
</script>
